import { render, staticRenderFns } from "./FooterComp.vue?vue&type=template&id=070775f0&scoped=true&"
import script from "./FooterComp.vue?vue&type=script&lang=js&"
export * from "./FooterComp.vue?vue&type=script&lang=js&"
import style0 from "./FooterComp.vue?vue&type=style&index=0&id=070775f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070775f0",
  null
  
)

export default component.exports